<form class="needs-validation" #f="ngForm" novalidate>
  <fieldset>
    <div class="modal-header">
      <p class="modal-title"><strong>Additional document request</strong></p>
        <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="col-12">
        <div class="row">
          <div class="col-md-4 mb-3 form-group">
            <label>Type of document</label>
            <select name="documentTypeId" type="number" class="form-select form-select-sm" [ngClass]="{ 'is-invalid': documentTypeId.invalid && (documentTypeId.dirty || f.submitted) && !isDocumentAdded }"
                    [(ngModel)]="fileDetails.docTypeId" #documentTypeId="ngModel" (change)="setCMDocTypes()" required>
              <option [ngValue]="null">Select</option>
              <option *ngFor="let type of getdistinctDocTypes" [ngValue]="type.docTypeId"
                      title="{{type.docTypeDisplayText}}" [ngClass]="{'grey-color': isDocuploaded(type,'docType')}">
                {{type.docTypeDisplayText}}
              </option>
            </select>
            <div *ngIf="documentTypeId.invalid" class="invalid-feedback">
              <div *ngIf="documentTypeId.errors.required">Document type is required</div>
            </div>
          </div>
          <div class="col-md-4 mb-3 form-group">
            <label>CM9 document name</label>
            <select name="documentNameId" type="number" class="form-select form-select-sm" [ngClass]="{ 'is-invalid': documentName.invalid && (documentName.dirty || f.submitted)  && !isDocumentAdded}"
                    [(ngModel)]="selectedDocName" (change) = "setDependent()" #documentName="ngModel" required>
              <option [ngValue]="null">Select</option>
              <option *ngFor="let type of documentTypes" [ngValue]="type" [ngClass]="{'grey-color': isDocuploaded(type,'docNameId')}">
                {{replaceGPNwithCode(type.docNameDisplayText)}}
              </option>

            </select>
            <div *ngIf="documentName.invalid" class="invalid-feedback">
              <div *ngIf="documentName.errors.required">Document name is required</div>
            </div>
          </div>
          <div class="col-md-4 mb-3 form-group">
            <label for="docNameId">Comment</label>
            <input type="text" name="comment" class="form-control form-control-sm"
                   [(ngModel)]="fileDetails.comment" #comment="ngModel" />

          </div>

          <div class="col-md-12 mb-3 form-group checkbox-inline">
            <input class="form-control form-control-sm" type="checkbox" class="check-input me-1"
                   [(ngModel)]="fileDetails.isMandatory"
                   name="isMandatory" #isMandatory="ngModel">
            <label class="ml-1">
              Is document mandatory ?
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 text-center mt-3">
        <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()"
                onclick="javascript:return false;">
          Cancel
        </button>
        <button class="btn btn-outline-primary me-2" (click)="addDocs(f)">
          Add documents
        </button>
      </div>
      <div class="col-12 mt-3 " *ngIf="requestedDocs.length > 0">
        <p><strong>Requested documents</strong></p>
        <div>
          <table class="table table-bordered" id="myTable">
            <thead>
              <tr>
                <th>
                  Type of document
                </th>
                <th>
                  Document name
                </th>

                <th>Comment</th>

                <th>Is Document mandatory</th>
              </tr>
            </thead>
            <tbody id="tableContent">
              <tr *ngFor="let item of requestedDocs">
                <td>
                  {{
                                    item.docTypeDisplayText
                  }}
                </td>
                <td>
                  {{item.docNameDisplayText}}
                </td>
                <td>
                  {{item.comment}}
                </td>

                <td>
                  {{item.isMandatory== true ? "Yes" : "No"}}
                </td>

                <!-- <td class="btnEdit"><a (click)="deleteDocs(item)"><img
                        src="design/images/delete.png" /></a></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 mt-3 " *ngIf="this.AddedDocs.length > 0">
        <p><strong>Newly requested documents</strong></p>
        <div>
          <table class="table table-bordered" id="myTable">
            <thead>
              <tr>
                <th>
                  Type of document
                </th>
                <th>
                  Document name
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody id="tableContent">
              <tr *ngFor="let item of AddedDocs">
                <td>
                  {{
item.docTypeDisplayText
                  }}
                </td>
                <td>
                  {{item.docNameDisplayText}}
                </td>
                <td class="btnEdit"><a (click)="deleteDocs(item)"><img src="design/images/delete.png" /></a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="this.AddedDocs.length > 0" class="col-12 text-center mt-3">
        <button class="btn btn-outline-primary me-2" (click)="requestDocuments()">
          Send request
        </button>

      </div>
    </div>
    </fieldset>
</form>
